import type { FC } from "react"
import React from "react"

const HatchPattern_Internal: FC<{
  id: string
  fill?: string
  stroke?: string
}> = ({ id, fill = `black`, stroke = `white` }) => {
  return (
    <defs>
      <pattern
        id={`pattern-hatch-${id}`}
        width="4"
        height="4"
        patternUnits="userSpaceOnUse"
        patternTransform="rotate(45)"
      >
        <rect
          width="2"
          height="4"
          strokeWidth={0.5}
          transform="translate(0,0)"
          fill={fill}
          stroke={stroke}
        />
      </pattern>
    </defs>
  )
}

export const HatchPattern = React.memo(HatchPattern_Internal)

const TilePattern_Internal: FC<{
  fill?: string
  id: string
  zoom: number
}> = ({ fill = `black`, id, zoom }) => {
  const zoomFactor = zoom / 100

  return (
    <defs>
      <pattern
        id={`pattern-tile-${id}`}
        width={1}
        height={1}
        patternUnits="userSpaceOnUse"
        patternTransform={`scale(${zoomFactor})`}
      >
        <rect width={1} height={1} transform="translate(0,0)" fill={fill} />
        <rect
          width={1}
          height={1}
          strokeWidth={0.05}
          transform="translate(0,0)"
          fill="transparent"
          stroke={fill}
        />
      </pattern>
    </defs>
  )
}
export const TilePattern = React.memo(TilePattern_Internal)
